import { useState, forwardRef } from 'react';
import {
  Typography,
  Box
} from '@mui/material';

interface FrequencySetterProps {
  value?: number[],
  setValue?: (e: any) => void,
}

const FrequencySetter = forwardRef((props: FrequencySetterProps, _ref) => {
  const [days] = useState(['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday']);

  const handleClick = (day) => {
    if(props?.value.includes(day)){
      props.setValue(props?.value.filter(e => e !== day));
    } else{
      props.setValue([...props?.value, day]);
    }
  }

  return (
    <Box display='flex' justifyContent='center' mb={2}>
      {days.map((day, i) => {
        return(
          <Box key={i} className='work-model-day'>
            <Box 
              key={i}
              onClick={() => {handleClick(i + 1)}} 
              className={ props?.value.includes(i + 1) ? 'work-model-date selected' : 'work-model-date'}>
                <Typography fontWeight={600} textAlign='center'>{day.substring(0,3)}</Typography>
            </Box>
          </Box>
        )
      })}
    </Box>
  );
});

export default FrequencySetter;
